import React from 'react';
import PropTypes from 'prop-types';
import { propOr } from 'ramda';

import './style.sass';
import { Grid, DropDown, FormsCollection } from '../../../../../../ui-kit';
import { INVOICES_PAY_TYPES } from '../../../../../../constants/crm';


const AddItemForm = ({
  values, errors, handleChange, setIsFormOpen, setTax,
  setTaxPaymentType, setFieldValue, currencySign, getPaymentType,
}) => (
  <div className="add-invoice-tax__form">
    <Grid.Row
      key="invoice-item-grid-addTaxForm"
      className="add-invoice-tax__row invoice-tax"
    >
      <Grid.ColData className="add-invoice-tax__col add-invoice-tax__col--details">
        <FormsCollection.Input
          name="tax"
          value={values.tax}
          error={propOr('', 'message', errors.tax)}
          touched
          onChange={(e) => {
            handleChange(e);
            setTax(e.target.value || 0);
          }}
          id="add-invoice-tax__field add-invoice-tax__field--tax"
          placeholderJump="Tax"
        />
      </Grid.ColData>
      <Grid.ColData className="add-invoice-tax__col add-invoice-tax__col--type-dropdown">
        <DropDown
          className="controls-group-task"
          name="tax_type"
          label={propOr('', 'label', getPaymentType(values.tax_type.value, currencySign))}
          currentItem={values.tax_type}
          onChange={({ val }) => {
            setFieldValue('tax_type', getPaymentType(val.value, currencySign));
            setTaxPaymentType(val.value);
          }}
          list={[
            {
              id: 1,
              label: 'Percent (%)',
              value: INVOICES_PAY_TYPES.PERCENT,
            },
            {
              id: 2,
              label: `Flat (${currencySign})`,
              value: INVOICES_PAY_TYPES.FLAT,
            },
          ]}
        />
      </Grid.ColData>
      <Grid.ColData className="add-invoice-tax__col add-invoice-tax__col--cancel-button">
        <button
          type="button"
          className="button--cancel disposable-form__cancel-button"
          onClick={() => {
            setIsFormOpen(false);
            setTax(0);
          }}
        >
          Cancel
        </button>
      </Grid.ColData>
    </Grid.Row>
  </div>
);

AddItemForm.propTypes = {
  values: PropTypes.instanceOf(Object).isRequired,
  errors: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  setIsFormOpen: PropTypes.func.isRequired,
  setTax: PropTypes.func.isRequired,
  setTaxPaymentType: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  currencySign: PropTypes.string,
  getPaymentType: PropTypes.func.isRequired,
};

AddItemForm.defaultProps = {
  currencySign: '$',
};

export default AddItemForm;
